import { FormattedMessage, defineMessages } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { fantasy } from '@sorare/core/src/lib/glossary';
import {
  PlayerSearchViewAttributes,
  StatsDisplay,
} from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from '../useManagePlayerSearchView';

const messages = defineMessages({
  perGame: {
    id: 'statsDisplayToggle.perMatch',
    defaultMessage: 'Per game',
  },
  per90: {
    id: 'statsDisplayToggle.per90',
    defaultMessage: 'Per 90’',
  },
  last15Total: {
    id: 'statsDisplayToggle.last15Total',
    defaultMessage: 'Last 15 total',
  },
});

const labels = {
  [Sport.FOOTBALL]: {
    on: messages.last15Total,
    off: messages.per90,
  },
  [Sport.BASEBALL]: {
    on: fantasy.total,
    off: messages.perGame,
  },
  [Sport.NBA]: {
    on: fantasy.total,
    off: messages.perGame,
  },
};

export const StatsDisplayToggle = () => {
  const { sport } = useSportContext();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();

  const statsDisplay = statsManager[PlayerSearchViewAttributes.STATS_DISPLAY];
  return (
    <TextSwitch
      checked={statsDisplay === StatsDisplay.TOTAL}
      compact
      onChange={() =>
        updatePlayerSearchViewAttribute(
          PlayerSearchViewAttributes.STATS_DISPLAY,
          statsDisplay === StatsDisplay.TOTAL
            ? StatsDisplay.PER_MATCH
            : StatsDisplay.TOTAL
        )
      }
      onLabel={<FormattedMessage {...labels[sport].on} />}
      offLabel={<FormattedMessage {...labels[sport].off} />}
    />
  );
};
